import { type ReactNode } from 'react';

export function Vignette(): ReactNode {
  return (
    <div
      className="pointer-events-none absolute inset-0"
      aria-hidden
      style={{
        background:
          'radial-gradient(ellipse at center, transparent 50%, rgba(0,0,0,0.6) 100%)',
      }}
    />
  );
}
